export enum ModelType{
    DOCUMENTS_REQUEST="Documents request",
    CONTRATS="Contrats"
}